<template>
     <div class="row">{{tabActiveFunction}}
        <div class="col-12 customSpaceTop">
            <ul class="fixedMiddleHeaderTab d-flex align-items-center holderCss">
                <li :class="(loadServiceRequest == 'requestServiceElement')? 'active' : ''" v-on:click.prevent="enableRequestElement('requestServiceElement')"><a href="#">{{$t('suppIndex_requestServices')}}</a></li>
                <li :class="(loadServiceRequest == 'openRequest')? 'active' : ''" v-on:click.prevent="enableRequestElement('openRequest')"><a href="#" > {{$t('suppIndex_OpenRequests')}}</a></li>
                <li :class="(loadServiceRequest == 'closeRequest')? 'active' : ''" v-on:click.prevent="enableRequestElement('closeRequest')"><a href="#">{{$t('suppIndex_ClosedRequests')}} </a></li>
            </ul>
        </div>
        <div class="col-12" v-if="loadServiceRequest == 'requestServiceElement'">
             <div class="ServceRequest">
                <app-request-services ></app-request-services>
             </div>
        </div>
        <div class="col-12 mb-4"  v-if="loadServiceRequest == 'openRequest'">
             <app-ticket-support ></app-ticket-support> 
        </div>
        <div class="col-12 mb-4" v-if="loadServiceRequest == 'closeRequest'">
            <app-ticket-support ></app-ticket-support>
        </div>



        <!---------------------------------------------Contact Form--------------------------------------------------->

        <!-- <div class="stepForm customContactForm">
            <h3>Contact Form</h3>
            <div class="row">
                <div class="col-12 col-md-6">
                    <div class="form-group field-wrapper">
                        <div class="position-relative">
                            <input placeholder=" " type="text" name="email" class="float-field form-control"/>
                            <label for="username" class="float-label">Full Real Name</label>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-md-6">
                    <div class="form-group field-wrapper">
                        <div class="position-relative">
                            <input placeholder=" " type="text" name="email" class="float-field form-control"/>
                            <label for="username" class="float-label">Phone Number</label>
                        </div>
                    </div>
                </div>
                <div class="col-12">
                    <div class="form-group field-wrapper">
                        <div class="position-relative">
                            <select class="float-field form-control" onclick="this.setAttribute('value', this.value);" value="" name="timezone_offset" id="timezone-offset">
                                <option value=""></option>
                                <option value="-12:00">(GMT -12:00) Eniwetok, Kwajalein</option>
                                <option value="-11:00">(GMT -11:00) Midway Island, Samoa</option>
                                <option value="-10:00">(GMT -10:00) Hawaii</option>
                                <option value="-09:50">(GMT -9:30) Taiohae</option>
                                <option value="-09:00">(GMT -9:00) Alaska</option>
                                <option value="-08:00">(GMT -8:00) Pacific Time (US &amp; Canada)</option>
                                <option value="-07:00">(GMT -7:00) Mountain Time (US &amp; Canada)</option>
                                <option value="-06:00">(GMT -6:00) Central Time (US &amp; Canada), Mexico City</option>
                                <option value="-05:00">(GMT -5:00) Eastern Time (US &amp; Canada), Bogota, Lima</option>
                                <option value="-04:50">(GMT -4:30) Caracas</option>
                                <option value="-04:00">(GMT -4:00) Atlantic Time (Canada), Caracas, La Paz</option>
                                <option value="-03:50">(GMT -3:30) Newfoundland</option>
                                <option value="-03:00">(GMT -3:00) Brazil, Buenos Aires, Georgetown</option>
                                <option value="-02:00">(GMT -2:00) Mid-Atlantic</option>
                                <option value="-01:00">(GMT -1:00) Azores, Cape Verde Islands</option>
                                <option value="+00:00" selected="selected">(GMT) Western Europe Time, London, Lisbon, Casablanca</option>
                                <option value="+01:00">(GMT +1:00) Brussels, Copenhagen, Madrid, Paris</option>
                                <option value="+02:00">(GMT +2:00) Kaliningrad, South Africa</option>
                                <option value="+03:00">(GMT +3:00) Baghdad, Riyadh, Moscow, St. Petersburg</option>
                                <option value="+03:50">(GMT +3:30) Tehran</option>
                                <option value="+04:00">(GMT +4:00) Abu Dhabi, Muscat, Baku, Tbilisi</option>
                                <option value="+04:50">(GMT +4:30) Kabul</option>
                                <option value="+05:00">(GMT +5:00) Ekaterinburg, Islamabad, Karachi, Tashkent</option>
                                <option value="+05:50">(GMT +5:30) Bombay, Calcutta, Madras, New Delhi</option>
                                <option value="+05:75">(GMT +5:45) Kathmandu, Pokhara</option>
                                <option value="+06:00">(GMT +6:00) Almaty, Dhaka, Colombo</option>
                                <option value="+06:50">(GMT +6:30) Yangon, Mandalay</option>
                                <option value="+07:00">(GMT +7:00) Bangkok, Hanoi, Jakarta</option>
                                <option value="+08:00">(GMT +8:00) Beijing, Perth, Singapore, Hong Kong</option>
                                <option value="+08:75">(GMT +8:45) Eucla</option>
                                <option value="+09:00">(GMT +9:00) Tokyo, Seoul, Osaka, Sapporo, Yakutsk</option>
                                <option value="+09:50">(GMT +9:30) Adelaide, Darwin</option>
                                <option value="+10:00">(GMT +10:00) Eastern Australia, Guam, Vladivostok</option>
                                <option value="+10:50">(GMT +10:30) Lord Howe Island</option>
                                <option value="+11:00">(GMT +11:00) Magadan, Solomon Islands, New Caledonia</option>
                                <option value="+11:50">(GMT +11:30) Norfolk Island</option>
                                <option value="+12:00">(GMT +12:00) Auckland, Wellington, Fiji, Kamchatka</option>
                                <option value="+12:75">(GMT +12:45) Chatham Islands</option>
                                <option value="+13:00">(GMT +13:00) Apia, Nukualofa</option>
                                <option value="+14:00">(GMT +14:00) Line Islands, Tokelau</option>
                            </select>
                            <label for="username" class="float-label">Prefered Contact Time (GMT)</label>
                        </div>
                    </div>
                </div>
                <div class="col-12">
                    <div class="form-group field-wrapper">
                        <div class="position-relative">
                            <textarea placeholder=" "  name="email" class="float-field form-control"></textarea>
                            <label for="username" class="float-label">Question or Comments</label>
                        </div>
                    </div>
                </div>
                <div class="col-12">
                    <div class="form-group field-wrapper">
                        <div class="position-relative">
                            <p>Security question, please solve</p>
                            <div class="d-flex align-items-center securityQuestion">
                                <p class="multiply">7 * 7</p>
                                <input placeholder=" " type="text" name="email" class="float-field form-control answerDiv pt-0"/>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12">
                    <div class=" d-flex justify-content-between align-items-center ">
                        <button class="prism_btn btn_lg mt-3">Submit</button>
                    </div>
                </div>
            </div>
        </div> -->








    </div>
    
</template>
<script>      
    import { fxViewMixins } from '@/plugins/fxView'  
    import { Const } from '@/plugins/fxView/provider/candle-history/lib/const.cls'
    import requestServices from './request_services'
    import ticketSupport from './support'
    export default {
        name: 'SERVICES',
        mixins: [fxViewMixins],
        data () {
          return {
            loadServiceRequest : "requestServiceElement",
            ticket_status : "",
            pageLoader : false,
            loaderFuncRun : '1',
            setView : '',
          }
        }, 
        components: {
            appRequestServices: requestServices,
            appTicketSupport: ticketSupport
        },
        computed:{
            tabActiveFunction(){
                localStorage.setItem("tabName", this.$route.params.tabName);
                this.loadServiceRequest = localStorage.getItem("tabName", this.$route.params.tabName);
                this.ticket_status = (this.loadServiceRequest == 'openRequest' ? '0' : '3')
            }
        },
        methods:{
            enableRequestElement(elementName){
                this.loadServiceRequest = elementName
                this.$router.replace({ name: "fxView.support", params: {tabName:elementName}})
            }
        },
        created(){
            if(this.$store.getters[Const.GET_TICKET_REASON_LIST] != ''){
                this.loaderFuncRun = '0'
            }

            if(this.$route.params.page && this.$route.params.page  == 'view_dash'){
                this.setView = 'view_dash'
                this.enableRequestElement('openRequest')
            }
            this._runGetTicketReasonList({ 'globalParams' :{ },'localParams' :{"parameter" : this ,'loaderFuncRun' : this.loaderFuncRun}})
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/fxView/supports/index.vue